export default "__VITE_ASSET__B8qhs8UO__"